import { $api } from './interceptor';
import { ISolvencySnapshot } from 'views/types/solvency';

const solvencyApi = () => {
  const getSolvency = async () => {
    const { data } = await $api.get<ISolvencySnapshot>('/api/admin/solvency');
    return data;
  };

  return {
    getSolvency,
  };
};

export const solvencyService = solvencyApi();
